import styled from "styled-components";

const accentColor = "#39b54a";
const textColor = "#8290a2";

export const Container = styled.div`
  background: #f6f7f8;
  border-radius: 4px;
  padding: 20px;
  margin-top: 20px;
  position: relative;
`;

export const Title = styled.div`
  font-weight: 700;
  color: ${accentColor};
  font-size: 24px;
  padding-right: 10px;
  padding-bottom: 10px;
`;

export const Details = styled.div`
  font-size: 14px;
  color: ${textColor};
  font-weight: 500;
`;

export const Button = styled.button`
  border: 1px solid ${textColor};
  border-radius: 4px;
  color: ${textColor};
  background: #fff;
  font-size: 14;
  padding: 15px 13px 14px;
  margin-right: 10px;
`;

export const ApplyNow = styled.button`
  color: white;
  background: rgb(0, 113, 188);
  min-width: 100px;
  padding: 1em 0;
  border-radius: 4px;
  border: 1px solid ${textColor};
`;

export const IconList = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
  row-gap: 0.3rem;
  flex-wrap: wrap;
`;

export const IconItem = styled.li`
  display: inline-block;
  padding-right: 20px;
  display: inline-block;
  i {
    padding-right: 5px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Link = styled.a`
  text-decoration: none !important;
`;

export const AppliedJobMessage = styled.span`
  font-weight: bold;
  color: ${accentColor};

  @media (max-width: 1000px) {
    display: none;
  }
`;
